// redux/slices/categorySlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../config/axiosInstance";

// Async thunk to fetch categories
export const fetchCategories = createAsyncThunk(
  "category/fetchCategories",
  async () => {
    const res = await axiosInstance.get(`/api/categories`);
    return res.data;
  }
);

// Add new async thunk
export const fetchChildCategories = createAsyncThunk(
  "category/fetchChildCategories",
  async (parentCategoryId, thunkAPI) => {
    try {
      const res = await axiosInstance.get(
        `/api/categories?parentCategoryId=${parentCategoryId}`
      );
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || "Failed to fetch child categories"
      );
    }
  }
);

export const fetchCategoryById = createAsyncThunk(
  "category/fetchCategoryById",
  async (id, thunkAPI) => {
    try {
      const res = await axiosInstance.get(`/api/categories/${id}`);
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || "Failed to fetch products"
      );
    }
  }
);

const categorySlice = createSlice({
  name: "category",
  initialState: {
    list: [],
    childList: [],
    selected: null, // For single category details
    selectedLoading: false,
    loading: false,
    childLoading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCategories.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // Single category
      .addCase(fetchCategoryById.pending, (state) => {
        state.selectedLoading = true;
      })
      .addCase(fetchCategoryById.fulfilled, (state, action) => {
        state.selectedLoading = false;
        state.selected = action.payload;
      })
      .addCase(fetchCategoryById.rejected, (state, action) => {
        state.selectedLoading = false;
        state.error = action.error.message;
      })

      // Add cases for child categories
      .addCase(fetchChildCategories.pending, (state) => {
        state.childLoading = true;
      })
      .addCase(fetchChildCategories.fulfilled, (state, action) => {
        state.childLoading = false;
        state.childList = action.payload;
      })
      .addCase(fetchChildCategories.rejected, (state, action) => {
        state.childLoading = false;
        state.error = action.payload;
      });
  },
});

export default categorySlice.reducer;
